export function appProps(
	state: any = {},
	action: any,
) {
	return state;
}

